import imgViewerDirective from './imgViewer'
import drag from './drag'

export default function directive (app) {
  app.directive('imgViewer', imgViewerDirective)
  app.directive('drag', drag)
}



// WEBPACK FOOTER //
// ./src/directive/index.js